module.exports = __webpack_public_path__ + "img/clock02.2f681c07.svg";